import { render } from "./SpeedRegistration.vue?vue&type=template&id=5c9795aa&scoped=true"
import script from "./SpeedRegistration.vue?vue&type=script&lang=ts"
export * from "./SpeedRegistration.vue?vue&type=script&lang=ts"

import "./SpeedRegistration.vue?vue&type=style&index=0&id=5c9795aa&scoped=true&lang=scss"
import "./SpeedRegistration.vue?vue&type=style&index=1&id=5c9795aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5c9795aa"

export default script